export * from "/__w/wiggot-web/wiggot-web/packages/web-components/svg/MessengerSvg.tsx"